/*** IMPORTS FROM imports-loader ***/
var define = false;

// import { featuredSlider } from '../modules/featuredSlider';
import Flickity from 'flickity';

export function fancyTabs() {

  const tabsContainer = document.querySelector("[role=tablist]");
  const tabButtons = tabsContainer.querySelectorAll("[role=tab]");
  const tabPanels = document.querySelectorAll("[role=tabpanel]");

  const firstTab = document.querySelector('.tabs__item.selected');
  const firstTabWidth = firstTab.offsetWidth / tabsContainer.offsetWidth;

  tabsContainer.style.setProperty("--_left", firstTab.offsetLeft + "px");
  tabsContainer.style.setProperty("--_width", firstTabWidth);

  var featuredSliders = document.querySelectorAll('.featured__slider');
  featuredSliders.forEach(featuredSlider => {
    var flkty = new Flickity(featuredSlider, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      adaptiveHeight: true,
      on: {
        ready: function () {
          setTimeout(() => {
            flkty.resize();
            // tabsInit();
          }, 1000);
          // setTimeout(() => {
          //   $('.hide-on-load').attr('hidden', true);
          // }, 1000);
        }
      }
    });

    // setTimeout(() => {
    //   var sliderHeight = $('.featured__slider').innerHeight();
    //   $('.tab-panels').css('minHeight', sliderHeight + 'px');
    // }, 1500);
    tabsContainer.addEventListener("click", (e) => {
      setTimeout(() => {
        flkty.resize();
      }, 100);
    });
  });

  var featuredSliderExists = document.querySelector('.featured__slider');

  tabsContainer.addEventListener("click", (e) => {
    const clickedTab = e.target.closest("button");
    const currentTab = tabsContainer.querySelector('[aria-selected="true"]');

    if (!clickedTab || clickedTab === currentTab) return;

    switchTab(clickedTab);
  });

  tabsContainer.addEventListener("keydown", (e) => {
    switch (e.key) {
      case "ArrowLeft":
        moveLeft();
        break;
      case "ArrowRight":
        moveRight();
        break;
      case "Home":
        e.preventDefault();
        switchTab(tabButtons[0]);
        break;
      case "End":
        e.preventDefault();
        switchTab(tabButtons[tabButtons.length - 1]);
        break;
    }
  });

  function moveLeft() {
    const currentTab = document.activeElement;

    if (!currentTab.previousElementSibling) {
      tabButtons.item(tabButtons.length - 1).focus();
    } else {
      currentTab.previousElementSibling.focus();
    }
  }

  function moveRight() {
    const currentTab = document.activeElement;
    if (!currentTab.nextElementSibling) {
      tabButtons.item(0).focus();
    } else {
      currentTab.nextElementSibling.focus();
    }
  }

  function switchTab(newTab) {
    const oldTab = tabsContainer.querySelector('[aria-selected="true"]');
    const activePanelId = newTab.getAttribute("aria-controls");
    const activePanel = tabsContainer.nextElementSibling.querySelector(
      "#" + CSS.escape(activePanelId)
    );
    tabButtons.forEach((button) => {
      button.setAttribute("aria-selected", false);
      button.classList.remove('selected');
      button.setAttribute("tabindex", "-1");
    });

    tabPanels.forEach((panel) => {
      if (featuredSliderExists) {
        panel.classList.add("hide-on-load");
      } else {
        panel.setAttribute("hidden", true);
      }
    });

    if (featuredSliderExists) {
      activePanel.classList.remove("hide-on-load");
    } else {
      activePanel.removeAttribute("hidden", false);
    }

    newTab.setAttribute("aria-selected", true);
    newTab.classList.add('selected');
    newTab.setAttribute("tabindex", "0");
    newTab.focus();
    moveIndicator(oldTab, newTab);
  }

  // move underline indicator
  function moveIndicator(oldTab, newTab) {
    const newTabPosition = oldTab.compareDocumentPosition(newTab);
    const newTabWidth = newTab.offsetWidth / tabsContainer.offsetWidth;
    let transitionWidth;

    // if the new tab is to the right
    if (newTabPosition === 4) {
      transitionWidth =
        newTab.offsetLeft + newTab.offsetWidth - oldTab.offsetLeft;
    } else {
      // if the tab is to the left
      transitionWidth =
        oldTab.offsetLeft + oldTab.offsetWidth - newTab.offsetLeft;
      tabsContainer.style.setProperty("--_left", newTab.offsetLeft + "px");
    }

    tabsContainer.style.setProperty(
      "--_width",
      transitionWidth / tabsContainer.offsetWidth
    );

    setTimeout(() => {
      tabsContainer.style.setProperty("--_left", newTab.offsetLeft + "px");
      tabsContainer.style.setProperty("--_width", newTabWidth);
    }, 220);
  }

}
